<template>
  <card class="card" title="پروفایل کاربر">
    <div>
      <form @submit.prevent>
        <div class="form-row">
          <div class="col-12 col-lg-4"> 
            <div class="form-group text-right">
              <label for="name">نام</label>
              <input id="name" type="text" class="form-control" v-model="userData.name" placeholder="نام">
            </div>
          </div>
          <div class="col-12 col-lg-4">
            <div class="form-group text-right">
              <label for="family_name">نام خانوادگی</label>
              <input id="family_name" type="text" class="form-control" placeholder="نام و نام خانوادگی">
            </div>
          </div>

        </div>


        <div class="text-center">
          <p-button type="info"
                    round
                    @click.native.prevent="updateProfile">
            بروزرسانی پروفایل
          </p-button>
        </div>
        <div class="clearfix"></div>
      </form>
    </div>
  </card>
</template>
<script>
  export default {

    data() {
      return {};
    },
    props: {
      userData: {
        type: Object,
        default: () => {
          return {
            name: "",
            family_name: []
          };
        }
      }
    },
    methods: {
      updateProfile() {
        alert("Your data: " + JSON.stringify(this.user));
      }
    }
  };
</script>
<style>
</style>
